core.constant('messagesMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "APPLICATION" : {
          "MESSAGES" : "Komunikaty"
        },
        "TABBAR": {
        },
        "BREADCRUMB": {
        }
      },
      "MODULE": {
        "TITLE": {
        },
        "MESSAGES": {
          "MESSAGES" : "Komunikaty",
          "PUBLISH_DATE" :  "Data publikacji",
          "TITLE" : "Tytuł",
          "CONTENT" : "Treść",
          "YOU_CAN_GO_TO_PATIENT_CARD" : "Aby przejść do Danych Personalnych Pacjenta kliknij ",
          "HERE" : "tutaj"
        }
      }
    }
  }
});
